export const employeePositions = {
  ACC_ASSISTANT: 'ACC ASSISTANT',
  ACC_ASSOCIATE_PRODUCER: 'ACC ASSOCIATE PRODUCER',
  ACC_MERCHANDISE_COORDINATOR: 'ACC MERCHANDISE COORDINATOR',
  ACC_PHOTOGRAPHER: 'ACC PHOTOGRAPHER',
  ACC_SET_COORDINATOR: 'ACC SET COORDINATOR',
  ACC_STYLIST: 'ACC STYLIST',
  ASSISTANT_PRODUCER: 'ASSISTANT PRODUCER',
  ASSOCIATE_PRODUCER:'ASSOCIATE PRODUCER',
  BOYSWEAR_FIT_MODEL: 'BOYSWEAR FIT MODEL',
  BOYSWEAR_MODEL: 'BOYSWEAR MODEL',
  CHINESE_EDITOR: 'CHINESE EDITOR',
  CHINESE_TRANSLATOR: 'CHINESE TRANSLATOR',
  CONTENT_AND_LOCALIZATION_ASSOCIATE_PRODUCER: 'CONTENT AND LOCALIZATION ASSOCIATE PRODUCER',
  COPYWRITER: 'COPYWRITER',
  COPY_ASSISTANT: 'COPY ASSISTANT',
  COPY_MERCHANDISE_COORDINATOR: 'COPY MERCHANDISE COORDINATOR',
  ENGLISH_EDITOR: 'ENGLISH EDITOR',
  FRENCH_EDITOR: 'FRENCH EDITOR',
  FRENCH_TRANSLATOR: 'FRENCH TRANSLATOR',
  GIRLSWEAR_FIT_MODEL: 'GIRLSWEAR FIT MODEL',
  GIRLSWEAR_MODEL: 'GIRLSWEAR MODEL',
  HMU_ARTIST: 'HMU ARTIST',
  BEAUTY_SPECIALIST: 'BEAUTY SPECIALIST',
  HAIR_SPECIALIST: 'HAIR SPECIALIST',
  JAPANESE_EDITOR: 'JAPANESE EDITOR',
  JAPANESE_TRANSLATOR: 'JAPANESE TRANSLATOR',
  MENSWEAR_ASSISTANT: 'MENSWEAR ASSISTANT',
  MENSWEAR_ASSOCIATE_PRODUCER: 'MENSWEAR ASSOCIATE PRODUCER',
  MENSWEAR_FIT_MODEL: 'MENSWEAR FIT MODEL',
  MENSWEAR_MERCHANDISE_COORDINATOR: 'MENSWEAR MERCHANDISE COORDINATOR',
  MENSWEAR_MFL_ASSISTANT: 'MENSWEAR MFL ASSISTANT',
  MENSWEAR_MODEL: 'MENSWEAR MODEL',
  MENSWEAR_STYLIST: 'MENSWEAR STYLIST',
  RETOUCHER: 'RETOUCHER',
  RETOUCH_PRODUCER: 'RETOUCH PRODUCER',
  RTW_PHOTOGRAPHER: 'RTW PHOTOGRAPHER',
  RTW_SET_ASSISTANT: 'RTW SET ASSISTANT',
  RTW_SET_COORDINATOR: 'RTW SET COORDINATOR',
  STYLING_ROOM_COORDINATOR: 'STYLING ROOM COORDINATOR',
  WOMENSWEAR_ASSISTANT: 'WOMENSWEAR ASSISTANT',
  WOMENSWEAR_ASSOCIATE_PRODUCER: 'WOMENSWEAR ASSOCIATE PRODUCER',
  WOMENSWEAR_FIT_MODEL: 'WOMENSWEAR FIT MODEL',
  WOMENSWEAR_MERCHANDISE_COORDINATOR: 'WOMENSWEAR MERCHANDISE COORDINATOR',
  WOMENSWEAR_MFL_ASSISTANT: 'WOMENSWEAR MFL ASSISTANT',
  WOMENSWEAR_MODEL: 'WOMENSWEAR MODEL',
  WOMENSWEAR_STYLIST: 'WOMENSWEAR STYLIST',
  STYLING_ASSISTANT: 'STYLING ASSISTANT',
  INVENTORY_ASSISTANT: 'INVENTORY ASSISTANT',
  STUDIO_ASSISTANT_COORDINATOR: 'STUDIO ASSISTANT COORDINATOR',
  STUDIO_ASSISTANT: 'STUDIO ASSISTANT',
  EE_ASSISTANT: 'EE ASSISTANT',
  EE_ASSOCIATE_PRODUCER: 'EE ASSOCIATE PRODUCER',
  EE_MERCHANDISE_COORDINATOR: 'EE MERCHANDISE COORDINATOR',
  EE_PHOTOGRAPHER: 'EE PHOTOGRAPHER',
  EE_SET_COORDINATOR: 'EE SET COORDINATOR',
  EE_STYLIST: 'EE STYLIST',
  STILL_LIFE_SET_ASSISTANT: 'STILL-LIFE SET ASSISTANT',
  POIRIER_ASSISTANT: 'POIRIER ASSISTANT',
};

export const modelPositions = [
  employeePositions.WOMENSWEAR_MODEL,
  employeePositions.MENSWEAR_MODEL,
  employeePositions.WOMENSWEAR_FIT_MODEL,
  employeePositions.MENSWEAR_FIT_MODEL,
  employeePositions.HMU_ARTIST,
  employeePositions.HAIR_SPECIALIST,
  employeePositions.BEAUTY_SPECIALIST,
  employeePositions.BOYSWEAR_MODEL,
  employeePositions.BOYSWEAR_FIT_MODEL,
  employeePositions.GIRLSWEAR_MODEL,
  employeePositions.GIRLSWEAR_FIT_MODEL,
];

